import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-retrainings-dashboard',
  templateUrl: './retrainings-dashboard.component.html',
  styleUrls: ['./retrainings-dashboard.component.scss']
})
export class RetrainingsDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
